/*
 * @Descripttion:
 * @Author: zhanghang
 * @Date: 2023-07-14 10:39:10
 * @LastEditors: zhanghang
 * @LastEditTime: 2023-07-24 17:30:09
 */
export default {
  name: "青绿风格",
  value: "greenStyle",
  picture: "33c82fb720dd4bf2b95c83f4340180bd",
  style: {
    //页面
    dataviewPage: {
      //字体颜色
      fontColor: "#FFFFFF",
      //页面背景
      backgroundConfig: {
        active: "color",
        color: {
          type: "color",
          isTheme: false,
          value: "#000",
          image: "",
        },
        pattern: {
          image: "",
        },
      },
    },
    // 选中与未选中的样式
    dataViewSelectStyle: {
      defaultColor: "#fff",
      clickColor: "#00B7BC",
    },
    //面板标题 
    dataviewPanelText: {
      backgroundConfig: {
        active: "pattern",
        pattern: {
          image: "38170134a6014f23bec2d5acbbb85928",
          size: "100% 100%",
          repeat: "no-repeat",
          position: "center",
        },
      },
      //标题颜色
      titleColor: "#00B7BC",
      subTitleColor: "#5AAEF3"
    },
    //面板组件
    dataviewPanel: {
      //标题背景
      titleBackgroundConfig: {
        active: "pattern",
        pattern: {
          image: "38170134a6014f23bec2d5acbbb85928",
          size: "100% 100%",
          repeat: "no-repeat",
          position: "center",
        },
      },
      //标题颜色
      titleColor: "#00B7BC",
      //子标题
      subTitleColor: "#5AAEF3",
      //边框颜色
      borderColor: "#FFDC4C",
    },
    //头部横栏
    dataviewHeaderContent: {
      //标题背景
      titleBackgroundConfig: {
        active: "pattern",
        pattern: {
          image: "032f1a28d03741fcb76fe01af61ab8fc",
          size: "100% 100%",
          repeat: "no-repeat",
          position: "center",
        },
      },
      //标题颜色
      titleColor: "#00B7BC",
      //子标题
      subTitleColor: "#5AAEF3",
      //边框颜色
      borderColor: "#FFDC4C",
    },
    //表格组件
    dataviewTable: {
      barColors: ["#00B7BC"], // 柱体的背景色
      prop_headerBGC: "", // 统一的表头背景色
      prop_headerColor: "#00B7BC", // 统一的表头颜色
      contentColor: "#5AAEF3", // 统一的内容颜色
    },
    //图表组件
    dataviewGraph: {
      // 标题
      title: {
        labelColor: "#00B7BC",
      },
      // 图例
      legend: {
        labelColor: "#5AAEF3",
      },
      // 坐标系颜色控制
      axis: {
        labelColor: "rgba(238, 254, 255, 1)",
        lineColor: "rgba(220, 240, 255, 0.1)"
      },
      // 地图颜色设置
      map: {
        colors: ["rgba(18, 85,91,1)"], // 地图区域颜色
        labelColor: "#00B7BC", // 地图文字颜色
        borderColor: "rgba(220, 240, 255, 0.2)" // 地图边线文字
      },
      // 图形颜色设置
      commonStyle: {
        colors: [
          ["rgba(0,183,188,0.2)", "rgba(0,183,188,0.6)", "rgba(0,183,188,1)"],
          ["rgba(90,174,243,0.2)", "rgba(90,174,243,0.6)", "rgba(90,174,243,1)"],
          ["rgba(255,220,76,0.2)", "rgba(255,220,76,0.6)", "rgba(255,220,76,1)"],
          ["rgba(168,223,250,0.2)", "rgba(168,223,250,0.6)", "rgba(168,223,250,1)"],
          ["rgba(115,192,222,0.2)", "rgba(115,192,222,0.6)", "rgba(115,192,222,1)"],
          ["rgba(59,162,114,0.2)", "rgba(59,162,114,0.6)", "rgba(59,162,114,1)"],
          ["rgba(91,110,150,0.2)", "rgba(91,110,150,0.6)", "rgba(91,110,150,1)"]
        ],
        labelColor: "#5AAEF3",
      }
    },
    //图文组件
    dataviewKeyTrades: {
      backgroundConfigs: [], // 单个背景(里面对象则为背景的通用对象)
      attachObj: {
        // 统一
        nameColor: "#00B7BC",// 名称颜色
        valueColor: "#5AAEF3",// 值颜色
        unitColor: "#5AAEF3", // 单位颜色
      },
    },
  },
};
